import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UISelect from 'UIComponents/input/UISelect';
import Big from 'UIComponents/elements/Big';
import UIInputGroup from 'UIComponents/form/UIInputGroup';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
export let AuthStepItemType;
(function (AuthStepItemType) {
  AuthStepItemType["Password"] = "Password";
  AuthStepItemType["Text"] = "Text";
  AuthStepItemType["Select"] = "Select";
  AuthStepItemType["Email"] = "Email";
  AuthStepItemType["Url"] = "Url";
  AuthStepItemType["Html"] = "Html";
})(AuthStepItemType || (AuthStepItemType = {}));
export let UrlPartType;
(function (UrlPartType) {
  UrlPartType["Static"] = "Static";
  UrlPartType["Select"] = "Select";
  UrlPartType["Domain"] = "Domain";
  UrlPartType["Path"] = "Path";
})(UrlPartType || (UrlPartType = {}));
export let AuthStepType;
(function (AuthStepType) {
  AuthStepType["Step"] = "Step";
})(AuthStepType || (AuthStepType = {}));
const emailRegex = new RegExp('^.+@.+\\..{2,}$');
export function AuthStepItemView({
  item,
  help,
  label,
  params,
  onChange
}) {
  switch (item.type) {
    case AuthStepItemType.Password:
    case AuthStepItemType.Text:
      {
        const value = params[item.name];
        const inputType = item.type === AuthStepItemType.Password ? 'password' : 'text';
        return /*#__PURE__*/_jsx(UIFormControl, {
          label: label,
          required: item.required,
          help: help ? /*#__PURE__*/_jsx(UILink, {
            external: true,
            href: help,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "universalAuth.auth.helpText"
            })
          }) : null,
          children: /*#__PURE__*/_jsx(UITextInput, {
            type: inputType,
            onChange: event => onChange(item.name, event.target.value),
            value: value
          })
        });
      }
    case AuthStepItemType.Email:
      {
        const value = params[item.name];
        const isInvalid = value ? !emailRegex.test(value) : false;
        return /*#__PURE__*/_jsx(UIFormControl, {
          label: label,
          required: item.required,
          help: help ? /*#__PURE__*/_jsx(UILink, {
            external: true,
            href: help,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "universalAuth.auth.helpText"
            })
          }) : null,
          error: isInvalid,
          validationMessage: isInvalid ? /*#__PURE__*/_jsx(Small, {
            use: "error",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "universalAuth.defaultValidationErrors.Email"
            })
          }) : null,
          children: /*#__PURE__*/_jsx(UITextInput, {
            type: "email",
            onChange: event => onChange(item.name, event.target.value),
            value: value
          })
        });
      }
    case AuthStepItemType.Html:
      return /*#__PURE__*/_jsx(UIFormControl, {
        label: label,
        help: help ? /*#__PURE__*/_jsx(UILink, {
          external: true,
          href: help,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "universalAuth.auth.helpText"
          })
        }) : null,
        children: /*#__PURE__*/_jsx("div", {
          dangerouslySetInnerHTML: {
            __html: item.html
          }
        })
      });
    case AuthStepItemType.Select:
      {
        const value = params[item.name];
        return /*#__PURE__*/_jsx(UIFormControl, {
          label: label,
          required: item.required,
          help: help ? /*#__PURE__*/_jsx(UILink, {
            external: true,
            href: help,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "universalAuth.auth.helpText"
            })
          }) : null,
          children: /*#__PURE__*/_jsx(UISelect, {
            options: item.options.map(option => ({
              text: option.label,
              value: option.value
            })),
            value: value,
            onChange: event => onChange(item.name, event.target.value),
            menuWidth: "auto"
          })
        });
      }

    //  {type : 'Url', name: string, parts: array<urlPart>, required: bool}
    case AuthStepItemType.Url:
      {
        const name = item.name;
        const value = params[item.name];
        const urlStep = item;
        const renderedParts = urlStep.parts.map((part, index) => {
          const key = `${part.type}${index.toString()}`;
          const partValue = value ? value[index] : undefined;
          let child;
          let error = false;
          const validationMessages = [];
          switch (part.type) {
            case UrlPartType.Static:
              child = /*#__PURE__*/_jsx(Big, {
                style: {
                  lineHeight: '40px'
                },
                children: part.value
              });
              break;
            case UrlPartType.Select:
              child = /*#__PURE__*/_jsx(UISelect, {
                options: part.options.map(option => ({
                  text: option,
                  value: option
                })),
                value: partValue,
                onChange: event => {
                  const nextValue = event.target.value;
                  const nextValues = value && Array.isArray(value) ? value.slice() : new Array(urlStep.parts.length).fill('');
                  nextValues[index] = nextValue;
                  onChange(name, nextValues);
                },
                menuWidth: "auto"
              });
              break;
            case UrlPartType.Domain:
            case UrlPartType.Path:
              {
                if (part.validation) {
                  const isInvalid = partValue && !new RegExp(part.validation.regex).test(partValue);
                  if (isInvalid) {
                    error = true;
                    validationMessages.push( /*#__PURE__*/_jsx(Small, {
                      use: "error",
                      children: part.validation.message
                    }, `${part.type}${index.toString()}`));
                  }
                }
                child = /*#__PURE__*/_jsx(UITextInput, {
                  placeholder: part.placeholder,
                  value: partValue,
                  onChange: event => {
                    const nextValue = event.target.value;
                    const nextValues = value && Array.isArray(value) ? value.slice() : new Array(urlStep.parts.length).fill('');
                    nextValues[index] = nextValue;
                    onChange(name, nextValues);
                  }
                });
                break;
              }
            default:
              child = null;
          }
          if (index > 0 && child) {
            child = /*#__PURE__*/_jsx(UIInputStaticLabel, {
              text: part.type === 'Path' ? '/' : '.',
              position: "start",
              children: child
            });
          }
          return /*#__PURE__*/_jsx(UIFormControl, {
            error: error,
            validationMessage: validationMessages,
            "aria-label": part.type,
            children: child
          }, key);
        });
        return urlStep.parts.length === 1 ? /*#__PURE__*/_jsx(UIFormControl, {
          label: label,
          "aria-label": label,
          required: urlStep.required,
          help: help ? /*#__PURE__*/_jsx(UILink, {
            external: true,
            href: help,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "universalAuth.auth.helpText"
            })
          }) : null,
          children: renderedParts[0]
        }) : /*#__PURE__*/_jsx(UIInputGroup, {
          label: label,
          "aria-label": label,
          gap: true,
          use: "none",
          required: urlStep.required,
          help: help ? /*#__PURE__*/_jsx(UILink, {
            external: true,
            href: help,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "universalAuth.auth.helpText"
            })
          }) : null,
          children: renderedParts
        });
      }
    default:
      return null;
  }
}

// computes the initial params state, i.e. preselects the first dropdown option etc.
export function getParamDefaultsFromSteps(steps) {
  const params = {};
  for (let i = 0; i < steps.length; i++) {
    const step = steps[i];
    for (let j = 0; j < step.items.length; j++) {
      const {
        item
      } = step.items[j];
      if ('name' in item) {
        switch (item.type) {
          case 'Url':
            {
              const values = new Array(item.parts.length);
              for (let k = 0; k < item.parts.length; k++) {
                const part = item.parts[k];
                switch (part.type) {
                  case 'Static':
                    {
                      values[k] = part.value;
                      continue;
                    }
                  case 'Select':
                    if (part.options.length > 0) {
                      values[k] = part.options[0];
                      continue;
                    }

                  // eslint-disable-next-line
                  default:
                    values[k] = '';
                }
              }
              params[item.name] = values;
              break;
            }
          case 'Select':
            if (item.options.length > 0) {
              params[item.name] = item.options[0].value;
              continue;
            }
            break;
          default:
            params[item.name] = '';
        }
      }
    }
  }
  return params;
}
export function validateAuthStep(step, params) {
  for (let i = 0; i < step.items.length; i++) {
    const {
      item
    } = step.items[i];
    switch (item.type) {
      case 'Password':
      case 'Text':
        if (item.required && !params[item.name]) {
          return false;
        }
        break;
      case 'Select':
        {
          if (item.required) {
            const value = params[item.name];
            if (
            // missing value
            !value ||
            // not a valid option
            item.options.findIndex(o => o.value === value) === -1) {
              return false;
            }
          }
          break;
        }
      case 'Email':
        if (item.required && !emailRegex.test(params[item.name])) {
          return false;
        }
        break;
      case 'Url':
        for (let j = 0; j < item.parts.length; j++) {
          const part = item.parts[j];
          const values = params[item.name] || [];
          switch (part.type) {
            case 'Select':
              {
                const partValue = values[j];
                if (item.required && (
                // missing value
                !partValue ||
                // invalid option
                !part.options.includes(partValue))) {
                  return false;
                }
                break;
              }
            case 'Domain':
            case 'Path':
              if (item.required && !values[j]) {
                return false;
              } else if (part.validation && !new RegExp(part.validation.regex).test(values[j])) {
                return false;
              }
              break;

            /* Static */
            default:
              continue;
          }
        }
        break;
      default:
        continue;
    }
  }
  return true;
}
export function buildApiPayload(sessionId, steps, params, oAuthRedirectSearchParams, oAuthState, oAuthScope) {
  const payload = {
    sessionId,
    authParams: {},
    inputParams: {},
    upstreamParams: {},
    oAuthParams: undefined
  };
  steps.forEach(step => {
    step.items.forEach(({
      item
    }) => {
      if (item.type === AuthStepItemType.Url) {
        // a full url needs to be constructed from the url parts
        const value = params[item.name];
        const urlValues = value && Array.isArray(value) ? value : new Array(item.parts.length).fill('');

        // fill the static parts
        item.parts.forEach((part, partIx) => {
          if (part.type === UrlPartType.Static) {
            urlValues[partIx] = part.value;
          }
        });
        const pathIndex = item.parts.findIndex(part => part.type === UrlPartType.Path);
        const domainParts = pathIndex === -1 ? urlValues : urlValues.slice(0, pathIndex);
        const pathParts = pathIndex === -1 ? [] : urlValues.slice(pathIndex);
        const url = `${domainParts.map(domainPart => domainPart.trim()).join('.').replace(/^(https?|ftp):\/\//, '') // strip http(s):// or ftp://
        .replace(/\/$/, '') // strip trailing /
        }${pathParts.length > 0 ? `/${pathParts.map(pathPart => pathPart.trim()).join('/')}` : ''}`;
        payload.inputParams[item.name] = url;
      } else if ('name' in item) {
        const value = params[item.name];
        const trimmedValue = value && !Array.isArray(value) ? value.trim() : '';
        payload.inputParams[item.name] = trimmedValue;
      }
    });
  });

  // OAuth 2.0 specific params
  if (oAuthRedirectSearchParams && oAuthState) {
    oAuthRedirectSearchParams.forEach((value, key) => {
      payload.upstreamParams[key] = value;
    });

    // Add the OAuth 2.0 specific `state` and `scope` from frontend to `oauthParams`
    // This is necessary in case they need to be handled differently from `upstreamParams` in the backend.
    payload.oAuthParams = {
      state: oAuthState,
      scope: oAuthScope
    };
  }

  // For backwards compatibility, we copy `inputParams` to the `authParams`.
  // DataSyncExtensions and UnifiedAuth-service currently expect input params (and upstream params) to be in the auth params.
  // These will be fixed in the future.
  payload.authParams = Object.assign({}, payload.inputParams);
  return payload;
}